<ng-container *transloco="let t; read: 'auditEntry'">
  <ng-container *ngIf="auditEntry">
    <ng-container *ngIf="label; else defaultLabel">
      {{
        t('lastEditedWithLabel', {
          label: label,
          userDisplayName: userDisplayName$ | async,
          timestamp: auditEntry.timestamp | momentPipe,
        })
      }}
    </ng-container>
    <ng-template #defaultLabel>
      {{ t('lastEdited', { userDisplayName: userDisplayName$ | async, timestamp: auditEntry.timestamp | momentPipe }) }}
    </ng-template>
  </ng-container>
</ng-container>
